import useCompany from './useCompany'

const useWhatsappNumber = () => {
  const company = useCompany()
  return company?.whatsappNumber ?? ''
}

export default useWhatsappNumber
